import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PricingSection.css";

const PricingSection = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false); // ✅ Modal state

  const handlePickTemplate = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/create"); // ✅ Logged in → go to create
    } else {
      setShowAuthModal(true); // 🔥 Show modal if not logged in
    }
  };

  return (
    <section className="home-pricing-container">
      {/* ✅ New Main Frame Wrapping Everything */}
      <div className="pricing-main-frame">
        {/* Heading */}
        <div className="pricing-header-frame">
          <h2 className="pricing-heading">
            Tailored Plans for <br className="mobile-break" /> Your{" "}
            <br className="desktop-break" />Swift Request
          </h2>
          <p className="pricing-subtext">Flexible pricing for any individual</p>
        </div>

        {/* Pricing Card */}
        <div className="home-pricing-card-container">
          <div className="home-pricing-card">
            <div className="pricing-card-content">
              <div className="home-pricing-card-frame">
                <h3 className="pricing-card-title">Starter</h3>
                <p className="pricing-card-description">
                  This package offers the basic features you <br /> need to send a document
                </p>
              </div>
              <p className="pricing-card-price">$5.60</p>
              <p className="pricing-card-dispatch">/Dispatch</p>
            </div>
          </div>
        </div>

        {/* Blue Frame with Wave and Arrow Inside */}
        <div className="pricing-extra-frame">
          <img src="/wave.jpg" alt="Wave Background" className="wave-image" />

          <div className="inner-frame">
            <h3 className="frame-title">Free Templates</h3>
            <p className="frame-description">
              Designed to serve and help <br /> you make your work faster.
            </p>

            <div className="button-container">
              <img
                src="/arrow-icon.svg"
                alt="Arrow Icon"
                className="pricing-arrow-icon"
              />
              <button
                className="pick-template-button"
                onClick={handlePickTemplate}
              >
                Pick Template
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Auth Modal */}
      {showAuthModal && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            <h3>Login Required</h3>
            <p>
              Hey there! You’ll need to sign in or create an account before you can pick a
              template.
            </p>
            <div className="auth-modal-buttons">
              <button onClick={() => navigate("/login")}>Login</button>
              <button onClick={() => navigate("/signup")}>Sign Up</button>
              <button
                onClick={() => setShowAuthModal(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PricingSection;
